/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetMarketsPrices200Ok
 */
export interface GetMarketsPrices200Ok {
    /**
     * adjusted_price number
     * @type {number}
     * @memberof GetMarketsPrices200Ok
     */
    adjustedPrice?: number;
    /**
     * average_price number
     * @type {number}
     * @memberof GetMarketsPrices200Ok
     */
    averagePrice?: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetMarketsPrices200Ok
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetMarketsPrices200Ok interface.
 */
export function instanceOfGetMarketsPrices200Ok(value: object): value is GetMarketsPrices200Ok {
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetMarketsPrices200OkFromJSON(json: any): GetMarketsPrices200Ok {
    return GetMarketsPrices200OkFromJSONTyped(json, false);
}

export function GetMarketsPrices200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsPrices200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'adjustedPrice': json['adjusted_price'] == null ? undefined : json['adjusted_price'],
        'averagePrice': json['average_price'] == null ? undefined : json['average_price'],
        'typeId': json['type_id'],
    };
}

export function GetMarketsPrices200OkToJSON(json: any): GetMarketsPrices200Ok {
    return GetMarketsPrices200OkToJSONTyped(json, false);
}

export function GetMarketsPrices200OkToJSONTyped(value?: GetMarketsPrices200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adjusted_price': value['adjustedPrice'],
        'average_price': value['averagePrice'],
        'type_id': value['typeId'],
    };
}

